<template>
    <div class="rd-scope">

      <!-- ══════════════ HERO ══════════════ -->
      <section class="rd-hero" v-if="current_page['display_name']">
        <div class="rd-wrap">
          <h1>{{ current_page['display_name'] }}</h1>
        </div>
      </section>

      <!-- ══════════════ PAGE BODY ══════════════ -->
      <div class="rd-page-body">
        <article class="rd-prose" v-html="current_page['content']"></article>
      </div>

    </div>
</template>

<script>
    export default {
        name: 'Default',
        mounted() {
            $('.expand_parent .expand_trigger').on('click', function () {
                let expand_parent = $(this).closest('.expand_parent');
                let expand_wrapper = expand_parent.children('.expand_wrapper');
                if (expand_parent.hasClass('expand_parent_expanded')) {
                    expand_wrapper.animate({
                        height: 0
                    },500,function () {
                        expand_parent.removeClass('expand_parent_expanded')
                    });
                } else {
                    expand_wrapper.animate({
                        height: expand_wrapper.children('.expand_container').outerHeight()
                    },500,function () {
                        expand_parent.addClass('expand_parent_expanded')
                    });
                }
            });
        },
        data() {
            let current_object = this;
            let root = current_object.$root;
            let data_set = {
                current_page: {}
            };
            if (root.current_id.page && root.item_map && root.item_map.page && root.item_map.page[root.current_id.page]) {
                data_set.current_page = root.item_map.page[root.current_id.page];
            }
            return data_set;
        }
    }
</script>

<style scoped>
/* page-specific tokens */
.rd-scope{color:#0a1628;background:#fff;--rd-cream:#faf6ed;--rd-off:#f5f5f5;--rd-border-lt:rgba(10,22,40,.09);--rd-gold-pale:#f5e9c8;--rd-slate:#4a5568;--rd-slate-lt:#718096;--rd-text-md:#3d5268}

/* ── HERO (white) ── */
.rd-hero{background:#fff;border-bottom:1px solid var(--rd-border-lt);position:relative;overflow:hidden;padding:54px 0 48px}
.rd-hero::before{content:'';position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(223,172,93,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(223,172,93,.05) 1px,transparent 1px);background-size:52px 52px;opacity:.7}
.rd-hero::after{content:'';position:absolute;width:420px;height:420px;background:radial-gradient(ellipse,rgba(223,172,93,.10) 0%,transparent 65%);top:-80px;right:5%;pointer-events:none}
.rd-hero .rd-wrap{position:relative;z-index:2}
.rd-hero h1{font-size:38px;font-weight:800;color:var(--rd-navy);letter-spacing:-.01em;line-height:1.15;margin:0}

/* ── PAGE BODY ── */
.rd-page-body{padding:44px 32px;max-width:880px;margin:0 auto}

/* ── PROSE (DB-stored HTML content) ── */
.rd-prose{font-size:15.5px;color:#1f2a37;line-height:1.78}
.rd-prose > *:first-child{margin-top:0}
.rd-prose > *:last-child{margin-bottom:0}

.rd-prose h2{font-size:26px;font-weight:800;color:var(--rd-navy);margin:38px 0 14px;line-height:1.22;letter-spacing:-.01em;padding-bottom:10px;border-bottom:1px solid var(--rd-border-lt)}
.rd-prose h3{font-size:20px;font-weight:700;color:var(--rd-navy);margin:30px 0 12px;line-height:1.3;letter-spacing:-.005em}
.rd-prose h3:first-child{margin-top:0}
.rd-prose h4{font-size:16px;font-weight:700;color:var(--rd-navy);margin:24px 0 10px;line-height:1.35}
.rd-prose h5{font-size:14px;font-weight:700;color:var(--rd-navy);margin:20px 0 8px;text-transform:uppercase;letter-spacing:.06em}

.rd-prose p{margin:0 0 16px}
.rd-prose p:empty{display:none}

.rd-prose a{color:var(--rd-gold);font-weight:600;text-decoration:underline;text-decoration-color:rgba(223,172,93,.4);text-underline-offset:3px}
.rd-prose a:hover{color:#c79744;text-decoration-color:var(--rd-gold)}

.rd-prose strong,.rd-prose b{color:var(--rd-navy);font-weight:700}
.rd-prose em,.rd-prose i{font-style:italic}

.rd-prose ul,.rd-prose ol{margin:0 0 18px;padding-left:24px}
.rd-prose ul li,.rd-prose ol li{margin-bottom:8px;line-height:1.7}
.rd-prose ul li::marker{color:var(--rd-gold)}
.rd-prose ul ul,.rd-prose ol ol,.rd-prose ul ol,.rd-prose ol ul{margin:8px 0 8px}

.rd-prose img{max-width:100%;height:auto;border-radius:4px;margin:18px 0;border:1px solid var(--rd-border-lt)}

.rd-prose hr{border:none;border-top:1px solid var(--rd-border-lt);margin:30px 0}

.rd-prose blockquote{border-left:4px solid var(--rd-gold);background:var(--rd-cream);padding:16px 22px;margin:20px 0;font-style:italic;color:#1f2a37;border-radius:0 4px 4px 0}
.rd-prose blockquote p{margin:0}

.rd-prose table{width:100%;border-collapse:collapse;margin:22px 0;font-size:14px}
.rd-prose table th{background:var(--rd-navy);color:#fff;padding:11px 14px;text-align:left;font-size:11.5px;letter-spacing:.06em;text-transform:uppercase;font-weight:700}
.rd-prose table td{padding:11px 14px;border-bottom:1px solid var(--rd-border-lt);vertical-align:top;line-height:1.6}
.rd-prose table tr:nth-child(even) td{background:#f8f7f3}
.rd-prose table tr:hover td{background:var(--rd-cream)}

.rd-prose code{font-family:Consolas,Monaco,'Courier New',monospace;font-size:.92em;background:var(--rd-off);padding:2px 6px;border-radius:3px;border:1px solid var(--rd-border-lt);color:var(--rd-navy)}
.rd-prose pre{background:var(--rd-off);border:1px solid var(--rd-border-lt);border-radius:4px;padding:14px 18px;overflow-x:auto;margin:20px 0}
.rd-prose pre code{background:none;border:none;padding:0}

/* ── LEGACY CONTENT CLASSES (used inside DB-stored HTML) ── */

/* example_container */
.rd-prose >>> .example_container{
  background:var(--rd-cream);
  border:1px solid #ecd9a4;
  border-left:4px solid var(--rd-gold);
  border-radius:0 6px 6px 0;
  padding:20px 26px;
  margin:24px 0;
  text-align:left;
}
.rd-prose >>> .example_container > *:first-child{margin-top:0}
.rd-prose >>> .example_container > *:last-child{margin-bottom:0}
.rd-prose >>> .example_container h3,
.rd-prose >>> .example_container h4{
  font-size:11px;
  font-weight:700;
  letter-spacing:.18em;
  text-transform:uppercase;
  color:var(--rd-gold);
  margin:0 0 12px;
  padding:0;
  border:none;
}
.rd-prose >>> .example_container ul,
.rd-prose >>> .example_container ol{margin:8px 0 12px;padding-left:22px}
.rd-prose >>> .example_container ul li::marker{color:var(--rd-gold)}

/* highlight_text */
.rd-prose >>> .highlight_text{color:var(--rd-gold);font-weight:700}

/* highlight_title */
.rd-prose >>> .highlight_title{
  color:var(--rd-navy);
  font-size:1.25em;
  font-weight:700;
  display:block;
  margin:0 0 10px;
}

/* column_wrapper / column_container */
.rd-prose >>> .column_wrapper{display:grid;grid-template-columns:1fr 1fr;gap:28px;margin:20px 0;align-items:start}
.rd-prose >>> .column_wrapper.column_wrapper_3{grid-template-columns:1fr 1fr 1fr}
.rd-prose >>> .column_container{min-width:0}
.rd-prose >>> .column_container > *:first-child{margin-top:0}
.rd-prose >>> .column_container > *:last-child{margin-bottom:0}
.rd-prose >>> .column_title{font-size:17px;font-weight:700;color:var(--rd-navy);margin:0 0 10px}
.rd-prose >>> .column_content{font-size:14.5px;color:var(--rd-text-md);line-height:1.7}
.rd-prose >>> .column_thumb,
.rd-prose >>> .image_container img{max-width:100%;height:auto;border-radius:4px;border:1px solid var(--rd-border-lt)}
@media(max-width:680px){
  .rd-prose >>> .column_wrapper,
  .rd-prose >>> .column_wrapper.column_wrapper_3{grid-template-columns:1fr}
}

/* expand_* family */
.rd-prose >>> .expand_parent{
  background:#fff;
  border:1px solid var(--rd-border-lt);
  border-radius:4px;
  margin:14px 0;
  overflow:hidden;
}
.rd-prose >>> .expand_trigger{
  padding:14px 18px;
  font-weight:700;
  color:var(--rd-navy);
  background:var(--rd-cream);
  cursor:pointer;
  border-bottom:1px solid var(--rd-border-lt);
  display:flex;
  align-items:center;
  gap:10px;
}
.rd-prose >>> .expand_trigger .glyphicon{font-size:.85em;color:var(--rd-gold)}
.rd-prose >>> .expand_wrapper{display:block}
.rd-prose >>> .expand_container{padding:16px 20px}
.rd-prose >>> .expand_container > *:first-child{margin-top:0}
.rd-prose >>> .expand_container > *:last-child{margin-bottom:0}
.rd-prose >>> .expand_container .highlight_title{color:var(--rd-navy);font-size:1.15em}

/* expandable_image_container */
.rd-prose >>> .expandable_image_container{margin:18px 0;text-align:center}
.rd-prose >>> .expandable_image_container img{max-width:100%;height:auto;border-radius:4px;border:1px solid var(--rd-border-lt)}

/* section_content_row */
.rd-prose >>> .section_content_row{margin:14px 0}

/* standout_text */
.rd-prose >>> .standout_text{
  display:block;
  font-size:1.4em;
  font-weight:700;
  color:var(--rd-navy);
  padding:14px 0;
  border-top:1px solid var(--rd-border-lt);
  border-bottom:1px solid var(--rd-border-lt);
  margin:20px 0;
  text-align:center;
}

/* responsive */
@media(max-width:980px){
  .rd-page-body{padding:32px 24px}
  .rd-hero{padding:42px 0 36px}
  .rd-hero h1{font-size:30px}
}
</style>
